export default __webpack_public_path__ + "media/images/brighteon-social/logo_horiz-7b72419ab40b622051ff319f5acfe7ed.png";